function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  strokeWidth: ".5",
  strokeLinejoin: "bevel",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 39.84V18.26c0-1.47 1.2-2.67 2.67-2.67h22.28L38.93 1.98a3.47 3.47 0 014.9 0l3.16 3.17a3.48 3.48 0 01-.01 4.91L41.3 15.6h4.04c1.46 0 2.66 1.19 2.66 2.66v21.58c0 1.48-1.2 2.67-2.66 2.67H2.66A2.67 2.67 0 010 39.84zm44.63-.71V18.97h-6.8l-9.89 9.63c-.31.3-.72.47-1.15.48l-5.63.1a1.69 1.69 0 01-1.72-1.68l-.05-5.77c0-.46.18-.9.51-1.23l1.58-1.53H3.38v20.16h41.24zm-38.3-6.39c0-.93.75-1.69 1.68-1.69h30.64a1.7 1.7 0 010 3.38H8.01c-.93 0-1.69-.76-1.69-1.69zm16.48-6.97l3.26-.06 13.49-13.14-3.3-3.29-13.48 13.14.02 3.35zm19.17-15.55l2.63-2.56c.03-.03.02-.1-.01-.13l-3.16-3.16c-.04-.03-.1-.03-.14 0l-2.61 2.55 3.29 3.3z"
})));